<template>
 <div id="orderList">
 	<section class="allorder" v-for="item in orderData">
 			<p class="ordernumber">
 				<span class="color999 font-size8 float-left">订单号: {{item.orderId}}</span>
 				<span class="font-size8 float-right" :class="item.state==1?'color46c0ff':item.state==2?'colorff8900':item.state==3?'colorff8920':item.state==4?'colorff8900':item.state==5?'color333':'color333'">{{item.state==1?'待付款':item.state==2?'交易中':item.state==3?'待发货':item.state==4?'待收货':item.state==5?'交易成功':'交易关闭'}}</span>
 			</p>
 			<dl class="allorderlist" @click="orderInfo(item.orderId,item.tranType)">
 				<dt><img :src="urlPrefixImg+'/'+item.cateIcon" alt=""/></dt>
 				<dd class="allorderdd1">
 					<p class="color333 font-size9 pp1">{{item.tranEvent}}</p>
 					<!--<p class="color666 font-size8 pp1">{{item.pName}}</p>-->
 					<p class="color666 font-size8 pp1">{{item.tranType!=2?item.pName:item.num==1?item.pName:item.num+'Q币'}}</p>
 					<p class="color666 font-size8 pp1" v-show="item.tranType==2">充值账号：{{item.rechPhone}}</p>
 					<p class="color666 font-size8 pp1" v-show="(item.tranType==1)||(item.tranType==0)">数量：{{item.num}}</p>
 				</dd>
 				<dd class="float-right goodsdd1" v-show="item.tranType!=0">
 					<!--<span>{{item.amount.startsWith('V')?item.amount.slice(item.amount.indexOf('@')+1)+'V':item.amount.slice(item.amount.indexOf('@')+1)+'元'}}</span>-->
 					<span>{{item.amount | capitalize}}</span>
 					<!--<p class="goodsp2" v-show="item.state==4&&item.tranType==0">(含运费12.00元)</p>-->
 				</dd>
 				<dd class="float-right goodsdd2" v-show="item.tranType==0">
 					<p class="goodsp1 mt5">{{item.amount | capitalize}}</p>
 					<!--<p class="goodsp2" v-show="item.tranType==0">(含运费{{JSON.parse(item.freight).R}}元)</p>-->
 					<!--<p class="goodsp2" v-show="item.tranType==0">(含运费{{(item.amount.startsWith('R'))?(JSON.parse(item.freight).R+"元"):(item.payType==5)?(JSON.parse(item.freight).V+"元"):(JSON.parse(item.freight).V+"V")}})</p>-->
 					<!--<p class="goodsp2" v-show="item.tranType==0">(含运费{{(item.payType==1)?(JSON.parse(item.freight).R+"元"):(item.payType==2)?(JSON.parse(item.freight).R+"元"):(item.payType==3)?(JSON.parse(item.freight).R+"元"):(item.payType==4)?(JSON.parse(item.freight).V+"V"):(item.payType==5)?(JSON.parse(item.freight).V+"元"):(JSON.parse(item.freight).V+"V")}})</p>-->
 					<p class="goodsp2" v-show="item.tranType==0">(含运费{{(item.payType==1||item.payType==2||item.payType==3)?(JSON.parse(item.freight).R+"元"):(item.payType==4)?(JSON.parse(item.freight).V+"V"):(item.payType==5)?(JSON.parse(item.freight).V+"元"):(JSON.parse(item.freight).V+"V")}})</p>
 					<!--(item.state==4&&item.tranType==0)||(item.state==3&&item.tranType==0)-->
 				</dd>
 			</dl>
 			<p class="ordertime clearfix">
 				<span class="font-size8 color999 display-inline pt12">{{item.cTime}}</span>
 				<span  v-show="item.state==1">
 				  <a href="javascript:void(0)" class="impay" @click="impay(item.orderId)">立即支付</a>
 				  <a href="javascript:void(0)" class="impay imCancel" @click="btnCancel(item.orderId)">取消订单</a>
 				</span>
 				<a href="javascript:void(0)" class="impay tradState" v-show="item.state==5" @click="reorder(item.orderId,item.tranType)">再来一单</a>
 				<a href="javascript:void(0)" class="impay tradState" v-show="item.state==6" @click="reorder(item.orderId,item.tranType)">重新购买</a>
 				<span class="goodsflag">
	 				<a href="javascript:void(0)" class="impay1 tradState mr4 ml6" v-show="item.state==4&&item.tranType==0" @click="confirmgetgoods(item.orderId)">确认收货</a>
	 				<a href="javascript:void(0)" class="impay1 tradState" v-show="item.state==4&&item.tranType==0" @click="tolookLogistics(item.orderId)">查看物流</a>
 				</span>
 			</p>
 			<p class="colorBox"></p>
 	</section>
 </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  import { Indicator } from 'mint-ui'
  import { MessageBox } from 'mint-ui';
  export default{
		props:['orderData','states'],
		data(){
		return{
			urlPrefixImg:this.URL_PREFIX_IMG,
			urlPrefix:this.URL_PREFIX,
			spsuc:this.URL_PAY,//支付成功后返回页面
			md5sign:this.Act_md5sign,
			callbackUrl:'http://m.vcard8.com/*/Order/orderList?state='+this.states, //http://m.vcard8.com/#/Order/orderList?state=4   //http://m.vcard8.com/#/UserCenter
		  }
	    },
		created:function(){
	    },
	    filters:{
	      capitalize:function(val){
	      	 return val.startsWith('V')?val.slice(val.indexOf('@')+1)+'V':val.slice(val.indexOf('@')+1)+'元';
	      }
	    },
		methods: {
			//订单各个状态点击进去的跳转页面判断
	       orderInfo(orderId,tranType){
	       	    localStorage.setItem("orderId",orderId);
	       	    if(tranType==0){//实物类型判断
	       	     this.$router.push({path: "/Order/goodsorderInfo"});		
	       	    }else{
	       	     this.$router.push({path: "/Order/orderInfo"});	
	       	    }
	       },
	       //立即支付
	       impay(orderId){
	       	    this.$http.post(this.URL_PREFIX+"/order/createOrder.net",{orderId:orderId,spsuc:this.spsuc})
		  	    .then((res) =>{
			  	  if(res.data.code!=200){
			  	  	  Toast(res.data.msg);
			  	  }else{
			  	  	  var orderId=res.data.remarks;
			  	  	  localStorage.setItem("orderId",orderId);
			  	  	  location.href=res.data.obj;
			  	  }
		  	   });
	       },
	       //查看物流
		   tolookLogistics(orderid){
		    	this.$http.post(this.URL_PREFIX+"/order/findLogisticsByOrderId.net",{orderid:orderid,callbackUrl:this.callbackUrl})
			    .then((res) =>{
			    	location.href=res.data;
			    });
		   },
		   //确认收货
		   confirmgetgoods(orderid){
		   		MessageBox.confirm('',{message:'确认已收到商品?', title:'提示'}).then(action => {
                 this.confirmgetgoods2(orderid);
                 },
	             action=>{
//	             	console.log('取消了删除操作');
	             },
	        	);   			   	 
		   },
		   confirmgetgoods2(orderid){
		   	  this.$http.post(this.URL_PREFIX+"/order/confirmReceipt.net",{orderId:orderid})
			    .then((res) =>{
			    	if(res.data.code==200){
			  	  	  Toast('确认收货成功！');
			  	  	  this.$router.push({path: "/Order/goodsorderInfo"});
			  	    }
			    });	
		   },
	       //再来一单，重新购买
	       reorder(orderId,tranType){
	       	   Indicator.open();
	       	    localStorage.setItem("ttype",tranType);
		        this.$http.post(this.URL_PREFIX+"/order/findOrderByProduct.net",{orderId:orderId})
		  	    .then((res) =>{
                   if(res.data.obj!=null){
			  	    	var pid=res.data.obj.proId;
			  	    	var num=res.data.obj.num;
			  	    	var goodstype=res.data.obj.tranType;
			  	    	if(goodstype==0){
			  	    		var orderaddressId=res.data.obj.addressId;//再次下单地址ID 
					     	localStorage.setItem("proName",res.data.obj.pName);//实物类型
					     	localStorage.setItem("tName",res.data.obj.tranEvent);//商品类型
					     	localStorage.setItem("ttype",res.data.obj.tranType); //商品类型
					     	localStorage.setItem("pic",res.data.obj.cateIcon);//图标
					     	localStorage.setItem("orderIdflag",res.data.obj.orderId);//订单列表返回标志
					     	localStorage.setItem("num",num);//数量
					     	localStorage.setItem("pid",pid);//商品ID
					     	var obj=JSON.stringify(res.data.obj.pays);
					     	localStorage.setItem("payType",obj);		
					        localStorage.setItem("freightR",res.data.obj.freight.R);  //保存人民币的运费
		     	            localStorage.setItem("freightV",res.data.obj.freight.V);  //保存V币的运费
		     	            localStorage.setItem("totalPrice",res.data.obj.amount);//总金额
					     	localStorage.setItem("totalPriceOb",(res.data.obj.amount-res.data.obj.freight.R).toFixed(2));//总金额-运费
					     	//this.validateStock(pid,num);//实物库存监控
			                Indicator.close();
			                this.$router.push({path: '/Order/index',query:{selectId:orderaddressId}});
			  	    	}else{
				  	    	localStorage.setItem("price",res.data.obj.amount);
					     	localStorage.setItem("proName",res.data.obj.pName);
					     	localStorage.setItem("ttype",res.data.obj.tranType);
					        localStorage.setItem("type",res.data.obj.tranType);
					     	localStorage.setItem("pic",res.data.obj.cateIcon);
					     	localStorage.setItem("tName",res.data.obj.tranEvent);
					     	localStorage.setItem("pid",pid);
					     	var obj=JSON.stringify(res.data.obj.pays);
					     	localStorage.setItem("payType",obj);
					     	localStorage.setItem("num",num);//数量
					     	localStorage.setItem("totalPrice",res.data.obj.amount);//总金额
					     	localStorage.setItem("citycode",res.data.obj.areaCode);//常登陆地
					     	localStorage.setItem("purpose",res.data.obj.purpose);//购买用途
					     	localStorage.setItem("account",res.data.obj.rechPhone);
					     	localStorage.setItem("freightR",res.data.obj.freight.R);  //保存人民币的运费
		     	            localStorage.setItem("freightV",res.data.obj.freight.V);  //保存V币的运费
					     	this.validateStock(pid,num);
			  	    	}
		  	        }else{
		  	    		Indicator.close();
		  	    		Toast(res.data.msg);
		  	    	}		  	    			  	    	
			    });
	       },
	       //库存风控验证
	       validateStock(pid,num,tranType){
	      	//Indicator.open();
	     	this.$http.post(this.URL_PREFIX+"/order/exisStock.net",{proId:pid,num:num})
		  	.then((res) =>{
		  	  	 Indicator.close();
		  	  	 if(res.data.code==200){
		  	  	 	this.$router.push({path: '/Order/index'});
		  	  	 }else{
		  	  	 	Toast(res.data.msg);
		  	  	 }
		    });
	     },
	     //取消订单
	      btnCancel(orderid){
	      	var _this=this;
		  	MessageBox.confirm('',{message:'您确认取消该订单吗?', title:'提示'}).then(action => {
	            var sign=md5('orderId='+orderid+'&'+this.md5sign);
		        this.$http.post(this.URL_PREFIX+"/activity/clearOrderById",{orderId:orderid,sign:sign})
			  	  .then((res) =>{
			  	  	   if(res.data.code!=200){
			  	  	   	  Toast(res.data.msg);
			  	  	   }else{
			  	  	   	  Toast("已取消");
			  	  	   	setTimeout(function(){
                           location.reload();
                        },300);
			  	  	   	
			  	  	   }
			  	});
		     },
		     action=>{
		
		     },
			  );
		  }
	    }
	}
</script>

<style scoped="scoped">
.allorder{background: #fff;padding: 12px 0 0 0;display: inline-block;width: 100%;}
.allorderlist{border-top: 1px solid #d6d6d6;border-bottom: 1px solid #eee;overflow: hidden;padding: 12px;}
.allorderlist dt img{width: 100%;}
.allorderlist dt{width: 50px;float: left;margin-top: 5px;}
.allorderlist .allorderdd1{float: left;margin-left: 10px;}
.allorderlist dd .pp1{line-height: 20px;}
.ordernumber{overflow: hidden;padding: 0 12px 12px 12px;}
.allorderlist .goodsdd1{line-height: 60px;color: #FF5513;font-size: 0.8rem;}
/*.allorderlist dd.float-right{float: right; }*/
.allorderlist .goodsdd2 .goodsp1{color: #FF5513;font-size: 0.8rem; text-align: center;}
.allorderlist .goodsdd2 .goodsp2{color: #757575;font-size: 0.7rem;}
.ordertime{padding: 0 12px 0 12px;height: 42px;}
.color46c0ff{color: #46c0ff;}
.impay{border: 1px solid #46c0ff;border-radius: 5px;-webkit-border-radius: 5px;color: #46c0ff;font-size: 0.9rem;float: right;text-align: center;padding: 2px 8px;margin-top: 7px;}
.imCancel{border: 1px solid #ddd;color: #666;margin-right: 8px;}
.btnkeypay{width: 100%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border: none;line-height: 40px;position: fixed;bottom: 0;}
.tradState{color: #ff8900;border:1px solid #ff8900;}
.impay1{
    border: 1px solid #ff8900;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    color: #ff8900;
    font-size: 0.9rem;
    text-align: center;
    padding: 2px 8px;
    margin-top: 7px;
}
.goodsflag{float: right;margin-top: 7px;}
</style>


// WEBPACK FOOTER //
// src/components/orderList.vue